/* Special Offer email popup — injected on marketing pages.
   Shows once per visitor (localStorage), 6.5s after first paint.
   Force it any time with ?popup=1. Step 1 submits the email to the Klaviyo
   Newsletter list; step 2 offers a text-only extra $10 (code TEXT10, sent by
   Klaviyo once the number joins the list; single opt-in since 2026-11-04, never shown here) and subscribes the phone to
   the SMS list. Both via bsKlaviyo (snippets/blackstage-klaviyo.liquid). */
(function(){
  var KEY = 'mpop_seen';
  // Headline discount. Pages can override with window.MPOP_OFF (T-008 ladders set '71%').
  // Default 54% -> 52% on 2026-11-04, when T-011's offer (52% max) became the default on all PDPs.
  var OFF = (typeof window.MPOP_OFF === 'string' && /^\d{1,2}%$/.test(window.MPOP_OFF)) ? window.MPOP_OFF : '52%';
  var force = new URLSearchParams(location.search).get('popup') === '1';
  // Production: once per visitor (force any time with ?popup=1).
  try { if (!force && localStorage.getItem(KEY)) return; } catch(e){}

  function build(){
    var wrap = document.createElement('div');
    wrap.className = 'mpop';
    wrap.innerHTML =
      '<div class="mpop-panel" role="dialog" aria-modal="true" aria-label="Special offer">' +
        // women's stage (body.stage-light): white-ground render + multiply — the dark render's screen blend bleaches on light (2026-10-30)
        (document.body.classList.contains('stage-light')
          ? '<img class="mpop-bottle ls" src="//maneuplabs.com/cdn/shop/t/27/assets/ls_p_bottle.jpg?v=134903757275498173451793380948" alt="Restore — Copper Tripeptide-1 serum">'
          : '<img class="mpop-bottle blend" src="//maneuplabs.com/cdn/shop/t/27/assets/bs_hero_bottle.jpg?v=171874919208921672911789439935" alt="Restore — Copper Tripeptide-1 serum">') +
        '<button class="mpop-x" aria-label="Close">&times;</button>' +
        '<div class="mpop-c">' +
          '<span class="mpop-badge">Special Offer</span>' +
          '<div class="mpop-kick">You&rsquo;ve Unlocked</div>' +
          '<div class="mpop-off"><small>Up To</small>' + OFF + ' OFF</div>' +
          '<p class="mpop-sub">Your first protocol. Drop your email and it&rsquo;s yours.</p>' +
          '<form class="mpop-form" novalidate>' +
            '<input type="email" required placeholder="Your email" aria-label="Email address">' +
            '<button type="submit" class="btn">Claim My Offer</button>' +
          '</form>' +
          '<button class="mpop-no">No thanks, I&rsquo;ll pay full price</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(wrap);

    function close(){
      try { localStorage.setItem(KEY, '1'); } catch(e){}
      wrap.classList.remove('on');
      setTimeout(function(){ wrap.remove(); }, 380);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e){ if (e.key === 'Escape') close(); }

    wrap.addEventListener('click', function(e){ if (e.target === wrap) close(); });
    wrap.querySelector('.mpop-x').addEventListener('click', close);
    wrap.querySelector('.mpop-no').addEventListener('click', close);
    document.addEventListener('keydown', onKey);

    function done(badge, kick, off, line){
      wrap.querySelector('.mpop-c').innerHTML =
        '<span class="mpop-badge">' + badge + '</span>' +
        '<div class="mpop-kick">' + kick + '</div>' +
        '<div class="mpop-off">' + off + '</div>' +
        '<p class="mpop-done">' + line + '</p>';
      setTimeout(close, 3200);
    }

    // Today's email-only confirmation (also the "No thanks" path from step 2).
    function emailDone(){
      done('Special Offer', 'You&rsquo;re In', '<small>Up To</small>' + OFF + ' OFF',
        'Locked to your email. Your pricing applies at checkout &mdash; watch your inbox.');
    }

    // Step 2: text-only $10 bonus. Shown after the email is captured, so it can't cost an email sign-up.
    function phoneStep(email){
      var c = wrap.querySelector('.mpop-c');
      c.innerHTML =
        '<span class="mpop-badge">Text-Only Bonus</span>' +
        '<div class="mpop-kick">Add Your Number For</div>' +
        '<div class="mpop-off"><small>Extra</small>$10 OFF</div>' +
        '<p class="mpop-sub">On top of your subscription price. We only send this code by text, so add your number and it&rsquo;s yours.</p>' +
        '<form class="mpop-form" novalidate>' +
          '<input type="tel" inputmode="tel" autocomplete="tel" required placeholder="(555) 123-4567" aria-label="Mobile number">' +
          '<button type="submit" class="btn">Text Me $10 Off</button>' +
        '</form>' +
        '<p class="mpop-legal" style="font-size:12px;line-height:1.5;color:var(--t55);max-width:340px;margin:12px auto 0;text-align:left;">' +
          'By clicking &ldquo;Text me $10 off&rdquo;, you agree to receive recurring automated marketing text messages (e.g. offers and cart reminders) from Maneup Labs at the number provided. Consent is not a condition of purchase. Msg &amp; data rates may apply. Msg frequency varies. Reply HELP for help or STOP to cancel. See our ' +
          '<a href="https://maneuplabs.com/policies/terms-of-service" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;">Terms</a> &amp; ' +
          '<a href="https://maneuplabs.com/policies/privacy-policy" target="_blank" rel="noopener" style="color:inherit;text-decoration:underline;">Privacy Policy</a>.' +
        '</p>' +
        '<button class="mpop-no">No thanks, I&rsquo;ll skip the extra $10</button>';
      var tel = c.querySelector('input[type="tel"]');
      var tracked = false;
      var attempt = 0;
      c.querySelector('.mpop-no').addEventListener('click', function(){
        emailDone();
      });
      function showErr(msg){
        var p = document.createElement('p');
        p.className = 'mpop-err';
        p.setAttribute('role', 'alert');
        p.style.cssText = 'font-size:13px;color:rgba(232,96,96,.9);margin:10px 0 0;';
        p.textContent = msg;
        c.querySelector('.mpop-form').insertAdjacentElement('afterend', p);
      }
      c.querySelector('.mpop-form').addEventListener('submit', function(e){
        e.preventDefault();
        var btn = c.querySelector('.mpop-form .btn');
        if (btn.disabled) return;
        var err = c.querySelector('.mpop-err');
        if (err) err.remove();
        // US-only offer and sending number: anything that isn't a valid US mobile never reaches Klaviyo.
        var phone = window.bsKlaviyo && window.bsKlaviyo.toE164(tel.value);
        if (!phone) {
          tel.setAttribute('aria-invalid', 'true'); tel.style.borderColor = 'rgba(232,96,96,.7)'; tel.focus();
          showErr('Please enter a US mobile number');
          return;
        }
        tel.removeAttribute('aria-invalid'); tel.style.borderColor = '';
        btn.disabled = true;
        attempt++;
        // Numbers already subscribed to texts don't rejoin the SMS list, so this event is what gets them the code.
        // Once per popup, so a retry can't text an already-subscribed customer the code twice.
        if (!tracked) window.bsKlaviyo.track(email, 'Requested Text Bonus', {source: 'Blackstage special-offer popup (SMS)'});
        tracked = true;
        // Only promise a text once Klaviyo has accepted the number.
        var info = {};
        var typed = tel.value.replace(/\D/g, '').length;
        window.bsKlaviyo.subscribeSms(email, phone, 'Blackstage special-offer popup (SMS)', info).then(function(ok){
          // Diagnostics for numbers that never land. Never the number itself: only its country code and digit counts.
          window.bsKlaviyo.track(email, 'Text Bonus Phone Result', {
            ok: ok, http_status: info.status, klaviyo_error_code: info.code, klaviyo_error_detail: info.detail,
            country_prefix: '+1', digits_sent: phone.replace(/\D/g, '').length, typed_digits: typed, attempt: attempt,
            source: 'Blackstage special-offer popup (SMS)'
          });
          if (ok) {
            done('You&rsquo;re In', 'Check Your Phone', '<small>Extra</small>$10 OFF',
              'Your $10 code is on its way by text. Your subscription pricing is already locked to your email.');
            return;
          }
          btn.disabled = false;
          showErr('That didn’t go through. Try again?');
        });
      });
      tel.focus();
    }

    wrap.querySelector('.mpop-form').addEventListener('submit', function(e){
      e.preventDefault();
      var em = wrap.querySelector('input[type="email"]');
      if (!em.value || em.value.indexOf('@') < 1) { em.focus(); return; }
      try { localStorage.setItem(KEY, '1'); } catch(err){}
      var email = em.value.trim();
      if (window.bsKlaviyo) {
        window.bsKlaviyo.subscribe(email, window.bsKlaviyo.LIST_NEWSLETTER, 'Blackstage special-offer popup');
        phoneStep(email);
      } else {
        emailDone();
      }
    });

    setTimeout(function(){ wrap.classList.add('on'); }, 30);
  }

  if (force) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
    else build();
  } else {
    setTimeout(build, 3000);
  }
})();
